import { render, staticRenderFns } from "./Adminportal.vue?vue&type=template&id=6fffdadb&"
import script from "./Adminportal.vue?vue&type=script&lang=js&"
export * from "./Adminportal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports